(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["WISHLIST_HERO_BKP_header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-sidebar-scroll"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  const buttons = document.querySelectorAll('.category-sidebar button');
  const rows = document.querySelectorAll('.category-row');

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;

      // active button
      buttons.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      // show content
      rows.forEach(row => {
        row.classList.remove('active');
        if (row.dataset.content === target) {
          row.classList.add('active');
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collections-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.tab-button');
    const collectionsContents = document.querySelectorAll('.collections-content');

    // Tab switching functionality
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.getAttribute('data-filter');

        // Remove active state from all
        buttons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');

        // Hide all collection blocks
        collectionsContents.forEach((content) => {
          content.classList.add('collections-content--hidden');
        });

        // Show selected content
        const selectedContent = document.querySelector(`[data-category="${filter}"]`);
        if (selectedContent) {
          selectedContent.classList.remove('collections-content--hidden');

          // 👉 Refresh Splide when tab becomes visible
          const slider = selectedContent.querySelector('.splide')._splide;
          if (slider) {
            setTimeout(() => slider.refresh(), 150);
          }
        }
      });
    });

    // Initialize Splide sliders for each tab block
    const splideSections = document.querySelectorAll('.collections-content .sp1');
    splideSections.forEach(function (section) {
      try {
        new Splide(section, {
          type: 'slide',
          perPage: 5,
          perMove: 1,
          speed: 600,
          gap: '10px',

          arrows: true,
          pagination: false,
          rewind: true,

          drag: true,
          swipe: true,

          flickPower: 150, // 🔥 LOWER = faster swipe
          flickMaxPages: 1,

          dragMinThreshold: {
            // 🔥 KEY FIX
            mouse: 2,
            touch: 5,
          },
          breakpoints: {
            480: {
              perPage: 1,
              gap: '8px',
            },
            768: {
              perPage: 3.5,
              gap: '10px',
            },
            1024: {
              perPage: 4.5,
            },
            1424: {
              perPage: 5,
            },
          },
        }).mount();
      } catch (e) {}
    });
  });

  document.querySelectorAll('.splide').forEach((slider) => {
    slider.addEventListener('drag', () => {
      slider.classList.add('is-dragging');
    });

    slider.addEventListener('dragged', () => {
      setTimeout(() => {
        slider.classList.remove('is-dragging');
      }, 50);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    const homeHeader = document.querySelector('.header-wrapper--home');
    if (!homeHeader) return;

    const sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;

    const updateHomeHeaderBg = () => {
      if (window.scrollY > 8) {
        sectionHeader.classList.add('header-has-bg');
      } else {
        sectionHeader.classList.remove('header-has-bg');
      }
    };

    window.addEventListener('scroll', updateHomeHeaderBg, { passive: true });
    updateHomeHeaderBg();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["multicolumn"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
const buttons = document.querySelectorAll('.tab-button');
const multicolumnContents = document.querySelectorAll('.multicolumn-content');

buttons.forEach(button => {
button.addEventListener('click', () => {
const filter = button.getAttribute('data-filter');

// Remove active class from all buttons
buttons.forEach(btn => btn.classList.remove('active'));
// Add active class to clicked button
button.classList.add('active');

// Hide all multicolumn contents
multicolumnContents.forEach(content => {
content.classList.add('multicolumn-content--hidden');
});

// Show the selected multicolumn content
const selectedContent = document.querySelector(`[data-category="${filter}"]`);
if (selectedContent) {
selectedContent.classList.remove('multicolumn-content--hidden');
}
});
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collections-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.tab-button');
    const collectionsContents = document.querySelectorAll('.collections-content');

    // Tab switching functionality
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.getAttribute('data-filter');

        // Remove active state from all
        buttons.forEach((btn) => btn.classList.remove('active'));
        button.classList.add('active');

        // Hide all collection blocks
        collectionsContents.forEach((content) => {
          content.classList.add('collections-content--hidden');
        });

        // Show selected content
        const selectedContent = document.querySelector(`[data-category="${filter}"]`);
        if (selectedContent) {
          selectedContent.classList.remove('collections-content--hidden');

          // 👉 Refresh Splide when tab becomes visible
          const slider = selectedContent.querySelector('.splide')._splide;
          if (slider) {
            setTimeout(() => slider.refresh(), 150);
          }
        }
      });
    });

    // Initialize Splide sliders for each tab block
    const splideSections = document.querySelectorAll('.collections-content .sp11');
    splideSections.forEach(function (section) {
      try {
        new Splide(section, {
          type: 'slide',
          perPage: 5,
          perMove: 1,
          speed: 600,
          gap: '10px',

          arrows: true,
          pagination: false,
          rewind: true,

          drag: true,
          swipe: true,

          flickPower: 150, // 🔥 LOWER = faster swipe
          flickMaxPages: 1,

          dragMinThreshold: {
            // 🔥 KEY FIX
            mouse: 2,
            touch: 5,
          },
          breakpoints: {
            480: {
              perPage: 1,
              gap: '8px',
            },
            768: {
              perPage: 3.5,
              gap: '10px',
            },
            1024: {
              perPage: 3.5,
            },
            1424: {
              perPage: 4.5,
            },
          },
        }).mount();
      } catch (e) {}
    });
  });

  document.querySelectorAll('.splide').forEach((slider) => {
    slider.addEventListener('drag', () => {
      slider.classList.add('is-dragging');
    });

    slider.addEventListener('dragged', () => {
      setTimeout(() => {
        slider.classList.remove('is-dragging');
      }, 50);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
